// src/pages/AgencyDetail.jsx
import React from "react";
import "../../assets/css/agency-detail.css";

import NavBarApp from "../../components/general/NavBarApp.jsx";
import AgencyDetailView from "../../components/agency/agencyDetailView.jsx";

const AgencyDetail = () => {
  return (
    <div className="main">
      <NavBarApp userType="interim" />
      <AgencyDetailView />
    </div>
  );
};

export default AgencyDetail;
